import React, { Component } from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { H4,Radiobutton, PopOver, Spinner } from '../../../components/index.js';
import renderRadiobutton, { Radiobutton as RadiobuttonControl } from '../../../components/ncss/Radiobutton.js';
import ServiceRequest from '../../../constants/json/radiobuttons/serviceRequest.json';
import { resolveLabLocationById } from '../../../util/labLocationHelpers.js';

class LabLocation extends Component {
  resolveLabSelection = (labLocationId, labId) => {
    const { labLocationCountries } = this.props;
    const resolvedLabLocationId = labLocationId ? Number(labLocationId) : null;
    const resolvedLabId = labId ? Number(labId) : null;

    if (resolvedLabLocationId && resolvedLabId && labLocationCountries && labLocationCountries.length) {
      for (let i = 0; i < labLocationCountries.length; i += 1) {
        const countryData = labLocationCountries[i];
        const match = countryData.location.find(loc =>
          Number(loc.id) === resolvedLabLocationId && Number(loc.labId) === resolvedLabId
        );
        if (match) {
          return {
            country: countryData.country,
            labId: resolvedLabId,
            labLocationId: resolvedLabLocationId
          };
        }
      }
    }

    return resolveLabLocationById(resolvedLabLocationId, labLocationCountries);
  };

  componentDidMount() {
    const { displaySubmitButtonTrf, displayClearButtonTrf } = this.props;
    displaySubmitButtonTrf(false);
    displayClearButtonTrf(true);
    this.syncEditLabLocationSelection();
  }

  getSelectedCountry() {
    const { labInfoStates, labLocationCountries, editLabLocationId, editLabId } = this.props;
    if (labInfoStates && labInfoStates.country) {
      return labInfoStates.country;
    }
    const labId = labInfoStates && labInfoStates.lab;
    const locationId = labId && labInfoStates[`location${labId}`];
    const lookupId = locationId || editLabLocationId;
    const lookupLabId = labId || editLabId;
    if (!lookupId) {
      return null;
    }
    const resolved = this.resolveLabSelection(lookupId, lookupLabId);
    if (resolved) {
      return resolved.country;
    }
    if (!labLocationCountries) {
      return null;
    }
    const countryData = labLocationCountries.find(entry =>
      entry.location.some(loc => String(loc.id) === String(lookupId))
    );
    return countryData ? countryData.country : null;
  }

  syncEditLabLocationSelection() {
    const { change, labInfoStates, editLabLocationId, editLabId, initialValues } = this.props;
    const isEdit = Boolean(initialValues && initialValues.trfId);
    if (!isEdit || !editLabLocationId) {
      return;
    }
    const resolved = this.resolveLabSelection(editLabLocationId, editLabId);
    if (!resolved) {
      return;
    }
    const locationField = `location${resolved.labId}`;
    const currentLocationId = labInfoStates && labInfoStates[locationField];
    if (String(currentLocationId) === String(resolved.labLocationId)
      && String(labInfoStates && labInfoStates.lab) === String(resolved.labId)
      && labInfoStates && labInfoStates.country === resolved.country) {
      return;
    }
    change('country', resolved.country);
    change('lab', resolved.labId);
    change(locationField, resolved.labLocationId);
  }

  componentDidUpdate(prevProps) {
    const { editLabLocationId, labLocationCountries, labLocationsLoading } = this.props;
    if (editLabLocationId !== prevProps.editLabLocationId
      || labLocationCountries !== prevProps.labLocationCountries
      || (prevProps.labLocationsLoading && !labLocationsLoading)) {
    }
  }

  locationObjSort() {
    const { labLocationCountries } = this.props;
    return labLocationCountries || [];
  }

  getLabIds() {
    const labIds = new Set();
    this.locationObjSort().forEach(countryData => {
      countryData.location.forEach(locationEntry => {
        labIds.add(locationEntry.labId);
      });
    });
    return Array.from(labIds);
  }

  clearLabSelection() {
    const { change } = this.props;
    this.getLabIds().forEach(labId => {
      change(`location${labId}`, null);
    });
    change('lab', null);
  }

  handleCountryChange = (event, newCountry, previousCountry) => {
    if (previousCountry !== undefined && newCountry !== previousCountry) {
      this.clearLabSelection();
    }
  };

  handleLocationChange = (labId, locationId) => () => {
    const { change, labInfoStates } = this.props;
    const prevLabId = labInfoStates && labInfoStates.lab;
    if (prevLabId && String(prevLabId) !== String(labId)) {
      change(`location${prevLabId}`, null);
    }
    change('lab', labId);
    change(`location${labId}`, locationId);
  };

  renderLocationField(locationEntry) {
    const { isPartialEdit } = this.props;
    const uniqueId = Number(`${locationEntry.labId}${locationEntry.id}`);
    return (
      <Field
        name={`location${locationEntry.labId}`}
        component={({ input }) => (
          <RadiobuttonControl
            name={input.name}
            value={locationEntry.id}
            checked={String(input.value) === String(locationEntry.id)}
            onChange={this.handleLocationChange(locationEntry.labId, locationEntry.id)}
            disabled={isPartialEdit}
            label={`${locationEntry.lab}, ${locationEntry.area}`}
            id={uniqueId}
            isIcon={false}
            translate="no"
          />
        )}
      />
    );
  }

  render() {
    const { sucessFill, isPartialEdit, labLocationsLoading } = this.props;
    const locationObj = this.locationObjSort();
    const selectedCountry = this.getSelectedCountry();
    return (
      <form className="form">
      <H4 className={sucessFill ? 'error-text' : 'error-hide'}>
      Location and Service Requested Fields are Mandatory
      <span className="astericks">&#42;</span>
      </H4>
      <div className="p2-sm">
      <H4 className="text-color-accent u-bold page-title-has-back sub-heading">LAB LOCATION</H4>
      </div>
      <div className=" ncss-col-sm-12 inline-flex-display u-bold pl0-sm">
      <div className="ncss-col-sm-2 description u-bold">
      Select Location <span className="astericks ml-neg3">&#42;</span>
      </div>

      <div className="ncss-col-sm-8">
      {labLocationsLoading ? (
        <Spinner className="spinner-lg" text="Loading..." />
      ) : (
        locationObj.length > 0 ? locationObj.map((countryData, index) => (
        <span key={countryData.country}>
        <div key={countryData.country} className="ncss-col-sm-4  u-bold pb1-sm">
        <span className="ncss-radio-container">
        <Field
          type="radio"
          component={renderRadiobutton}
          name="country"
          value={countryData.country}
          disabled={isPartialEdit}
          label={countryData.country}
          id={9000 + index}
          isIcon={false}
          translate='no'
          onChange={this.handleCountryChange}
        />
        </span>
        {selectedCountry === countryData.country ? (
        <PopOver>
          {countryData.location.length > 0 ? countryData.location.map(locationEntry => (
          <div key={`${locationEntry.labId}-${locationEntry.id}`} className=" ncss-radio-container">
          {this.renderLocationField(locationEntry)}
          </div>
          )) : null}
        </PopOver>
        ) : null}
        </div>
        </span>
      )) : null
      )}
      </div>
      </div>
      <div className="ncss-col-sm-12 description u-bold pt4-sm">
      Service Requested <span className="astericks ml-neg3">&#42;</span>
      </div>
      <div className=" ncss-col-sm-12 inline-flex-display">
      <div className="ncss-col-sm-12  ncss-form-group">
      {ServiceRequest.length > 0 ? ServiceRequest.map(data => (
        <div key={data.label} className="ncss-col-sm-4 ncss-radio-container">
        <Field
        type="radio"
        component={Radiobutton}
        name="serviceRequested"
        checked = {false}
        value={data.label}
        disabled={isPartialEdit}
        label={data.label}
        id={data.id}
        isIcon={false}
        />
        <span className="pl6-sm radio-sub-info">{data.sub}</span>
        </div>
      )) : null}
      </div>
      </div>
      </form>
    );
  }
}
LabLocation.propTypes = {
  sucessFill: PropTypes.bool,
  displaySubmitButtonTrf: PropTypes.func,
  displayClearButtonTrf: PropTypes.func,
  labInfoStates: PropTypes.object,
  change: PropTypes.func,
  labLocationCountries: PropTypes.array,
  labLocationsLoading: PropTypes.bool,
  isPartialEdit: PropTypes.bool,
  initialValues: PropTypes.object,
  editLabLocationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  editLabId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
const mapStateToProps = state => ({
  labInfoStates: getFormValues('labLocation')(state),
  labLocationCountries: state.trf.labLocationCountries,
  labLocationsLoading: state.trf.labLocationsLoading,
  editLabLocationId: state.trf.trfDataForEdit && state.trf.trfDataForEdit.labLocationId,
  editLabId: state.trf.trfDataForEdit && state.trf.trfDataForEdit.labId,
});
export default reduxForm({
  form: 'labLocation',
  initialValues: {
    serviceRequested: 'Regular'
  },
  destroyOnUnmount: false,
  enableReinitialize: true
})(
  connect(
    mapStateToProps
  )(LabLocation)
);
